import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Mail, Phone, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../App';

const PendingApprovalPage = () => {
  const { user, logout } = useAuth();

  // If user is already approved, redirect to dashboard
  if (user?.status === 'approved' || user?.role === 'admin' || user?.role === 'superadmin') {
    window.location.href = '/dashboard';
    return null;
  }

  return (
    <div className="min-h-screen bg-[#F2F0E9] flex items-center justify-center p-8" data-testid="pending-approval-page">
      <div className="max-w-lg w-full">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 mb-12 justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_golf-experience-hub/artifacts/amevwgso_logo-for-web%20copy.jpg" 
            alt="Quiet Mind Golf" 
            className="h-12 w-auto"
          />
          <span className="font-['Playfair_Display'] text-xl font-medium text-[#1A1A1A]">
            Quiet Mind Golf
          </span>
        </Link>

        <div className="bg-white border border-[#E7E5E4] p-8 md:p-12 text-center">
          <div className="w-20 h-20 bg-[#F2F0E9] rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-[#BC562B]" />
          </div>

          <h1 className="font-['Playfair_Display'] text-2xl md:text-3xl text-[#1A1A1A] mb-4">
            Account Pending Approval
          </h1>

          <p className="text-[#57534E] mb-6">
            Thank you for registering, <strong>{user?.full_name}</strong>! Your account is currently awaiting approval from Scott.
          </p>

          <div className="bg-[#F2F0E9] p-6 mb-8 text-left">
            <p className="text-sm text-[#737373] mb-4">
              You'll receive an email notification once your account has been approved. This usually happens within 24 hours.
            </p>
            <p className="text-sm text-[#737373]">
              If you have any questions, feel free to get in touch:
            </p>
            <div className="mt-4 space-y-2">
              <a href="mailto:scott@quietmindgolf.co.uk" className="flex items-center gap-2 text-[#2C5530] hover:underline text-sm">
                <Mail className="w-4 h-4" />
                scott@quietmindgolf.co.uk
              </a>
              <a href="tel:+447455558064" className="flex items-center gap-2 text-[#2C5530] hover:underline text-sm">
                <Phone className="w-4 h-4" />
                +44 7455 558064
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={logout}
              className="w-full border border-[#E7E5E4] text-[#57534E] px-6 py-3 text-sm font-semibold uppercase tracking-wider hover:bg-[#F2F0E9] transition-colors"
              data-testid="logout-btn"
            >
              Sign Out
            </button>
            <Link
              to="/"
              className="flex items-center justify-center gap-2 text-[#737373] hover:text-[#1A1A1A] text-sm"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Website
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
